import axios from 'axios';

export default {
  fetchDeliveryLocations(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/custom-infos", {params})
      .then(results=>{
        return results.data;
      })
  },
  fetchDeliveryTypes(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/delivery-types/")
      .then(results=>{
        return results.data;
      })
  },
  fetchPaymentMethods(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/payments/types")
    .then(genericPaymentTypesResponse=>{
      return genericPaymentTypesResponse.data;
    })
  },
  fetchPaymentTypeCategories(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/payments/categories")
    .then(genericPaymentTypesResponse=>{
      return genericPaymentTypesResponse.data;
    })
  },
  fetchCompanyRoles(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/tags?type=CONTACT_ROLE")
      .then(response=>{
        return response.data;
      })
  },
  fetchListValues(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/settings/values")
      .then(response=>{
        return response.data;
      })
  },
  fetchDeliveryScheduleExceptions(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/delivery-schedules/exceptions")
      .then(response=>{
        return response.data;
      })
  },
  fetchGLAccounts(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/general-ledger?ALL")
      .then(response=>{
        return response.data;
      })
  },
  fetchTaxes(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/taxes")
      .then(response=>{
        return response.data;
      })
  },
  fetchCreditNoteTypes(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/types")
      .then(response=>{
        return response.data;
      })
  },
  fetchTerritories(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/territories")
      .then(response=>{
        return response.data;
      })
  },
  fetchRebateTypes(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/rebates/types")
      .then(response=>{
        return response.data;
      })
  }


}
